//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
export default {
  name: "navBar",
  computed: {
    ...mapState(["currentUser"]),
  },
  data() {
    return {
      isAdmin: false,
      isUsers: false,
    };
  },
  mounted() {
    this.confirmRouter();
  },
  methods: {
    confirmRouter() {
      this.$route.path.includes("admin")
        ? (this.isAdmin = true)
        : (this.isAdmin = false);
      this.$route.path.includes("users")
        ? (this.isUsers = true)
        : (this.isUsers = false);
    },
    logout() {
      this.$store.commit("revokeAuthenication");
      this.$router.push("/signin");
    },
  },
};
